import React from 'react';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import FieldInput from '../../form/FieldInput';
import Button from '../../../common/buttons/onboarding/OnboardingButton';
import Heading from '../../../common/heading/Heading';
import truncateEmail from '../../helpers/truncateEmail';
import { validatePassword } from '../../../../helpers/validation';
import { deviceInformation } from '../../../../helpers/device';
import Message from '../../../common/message/Message';
import PasswordStrengthCheck from '../../common/passwordStrengthCheck/PasswordStrengthCheck';
import {
	ONBOARDING_NEW_PASSWORD_LABEL,
	ONBOARDING_NEW_PASSWORD_TITLE,
	ONBOARDING_NEW_PASSWORD_SUBTITLE,
	ONBOARDING_NEW_PASSWORD_CTA,
} from '../../../../constants/Copy';

const warn = ({ password }) => ({
	password: <PasswordStrengthCheck password={password} />,
});

const validate = ({ password }) => ({
	password: validatePassword({ password }).valid ? (
		false
	) : (
		<PasswordStrengthCheck password={password} showErrors />
	),
});

const NewPasswordForm = ({ submitting, handleSubmit, pristine, invalid, email }) => {
	return (
		<form
			method="post"
			className="onboarding__form onboarding-new-password"
			onSubmit={handleSubmit}
		>
			<Heading>{ONBOARDING_NEW_PASSWORD_TITLE}</Heading>
			<p className="onboarding__text">
				<Message
					message={ONBOARDING_NEW_PASSWORD_SUBTITLE}
					values={{ email: truncateEmail(email, 28) }}
				/>
			</p>

			<Field
				name="password"
				type="password"
				autoFocus
				label={ONBOARDING_NEW_PASSWORD_LABEL}
				component={FieldInput}
				showPassword={deviceInformation.isMobile}
				autocomplete="new-password"
				testId="new-password-input"
				showPasswordStrengthCheck
			/>

			<Button
				loading={submitting}
				disabled={submitting || pristine || invalid}
				testId="new-password-button"
				type="submit"
			>
				{ONBOARDING_NEW_PASSWORD_CTA}
			</Button>
		</form>
	);
};

NewPasswordForm.propTypes = {
	handleSubmit: PropTypes.func.isRequired,
	email: PropTypes.string.isRequired,
};

export default reduxForm({
	form: 'newPassword',
	validate,
	warn,
})(NewPasswordForm);
